import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

const body = document.querySelector("body");

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
  let button = document.querySelector('.hd_menu_btn');
  let nav_box = document.querySelector('.hd_nav_box');

  if (button && nav_box) {
    button.addEventListener('click', function() {

      if (nav_box.classList.contains('is_open')) {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      } else {
        nav_box.classList.add("is_open");
        button.classList.add("is_close");
      }

    });
  }

/*------------------------------------------------
ハンバーガーメニュー　リンク押したらメニュー閉じる
--------------------------------------------------*/
  let links = document.querySelectorAll('.header-nav__link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });


/*----------------------------------------
お問い合わせ アニメーション
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
function getHeaderHeight() {
  const header = document.querySelector('.header');
  return header ? header.offsetHeight : 0;
}

document.addEventListener('tccf7:scrollTo', e => {
  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: getHeaderHeight()
    },
    ease: "power2.inOut"
  });
});

/*----------------------------------------
お問い合わせバリデーション
------------------------------------------*/
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}

/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
gsap.registerPlugin(ScrollToPlugin);
window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      e.preventDefault();
      const id = navLink.getAttribute("href");
      const currentOffset = window.innerWidth <= 1024 ? 60 : 165;

      // ★スクロール開始の通知を飛ばす
      window.dispatchEvent(new CustomEvent('gsapScrollStart'));

      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: id,
          offsetY: currentOffset
        },
        // ★アニメーション完了時に、スクロール終了の通知を飛ばす
        onComplete: () => {
          window.dispatchEvent(new CustomEvent('gsapScrollEnd'));
        }
      });
    });
  });
});

/*----------------------------------------
smooth scroll page外リンク（瞬時に移動）
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      // gsap.to を gsap.set に変更（durationは不要になります）
      gsap.set(window, {
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 0);
  }
});

/*----------------------------------------
  serviceページのカレント
------------------------------------------*/
/*----------------------------------------
  serviceページのカレント
------------------------------------------*/
(function() {
  window.addEventListener('DOMContentLoaded', () => {
    if (!window.location.pathname.includes('service')) return;

    const links = document.querySelectorAll('.header-nav__link');
    const currentClass = 'is_active';
    const reset = () => links.forEach(link => link.classList.remove(currentClass));

    const linkVilla = document.querySelector('.header-nav__item:nth-of-type(3) .header-nav__link');
    const linkFacility = document.querySelector('.header-nav__item:nth-of-type(4) .header-nav__link');
    const secVilla = document.getElementById('villa');
    const secFacility = document.getElementById('facility');

    // ★スクロールアニメーション中かどうかのフラグ
    let isScrolling = false;

    // ★GSAP側からのイベントをキャッチしてフラグを制御
    window.addEventListener('gsapScrollStart', () => { isScrolling = true; });
    window.addEventListener('gsapScrollEnd', () => { isScrolling = false; });

    // 初期読み込み時のハッシュ判定
    reset();
    if (window.location.hash === '#facility') {
      linkFacility?.classList.add(currentClass);
    } else {
      linkVilla?.classList.add(currentClass);
    }

    // スクロール時の監視
    if (secVilla && secFacility) {
      const observer = new IntersectionObserver((entries) => {
        // ★GSAPが動いている間はスクロール監視を無視する
        if (isScrolling) return;

        entries.forEach(entry => {
          if (entry.isIntersecting) {
            reset();
            const activeLink = entry.target.id === 'villa' ? linkVilla : linkFacility;
            activeLink?.classList.add(currentClass);
          }
        });
      }, { rootMargin: '-30% 0px -30% 0px' });

      observer.observe(secVilla);
      observer.observe(secFacility);
    }

    // カレント側でのクリックイベント（クリックした瞬間にクラスを確定させる）
    [linkVilla, linkFacility].forEach(link => {
      link?.addEventListener('click', () => {
        reset();
        link.classList.add(currentClass);
      });
    });
  });
})();

/*------------------------------------------------
初回のみOPアニメーション表示
--------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const loading = document.getElementById('svgLoading');
  const firstVisit = sessionStorage.getItem('firstVisit') !== 'done';

  if (firstVisit) {
    loading.classList.add('show'); //クラス追加

    setTimeout(() => {
      loading.style.opacity = '0';
      loading.style.transition = 'opacity 1.5s ease';

      setTimeout(() => {
        loading.remove();
      }, 2000);

    },5000);

    sessionStorage.setItem('firstVisit', 'done');
  } else {
    loading.remove();
  }
});